import {
  compose,
  border,
  BorderProps,
  color,
  BackgroundColorProps,
  typography,
  TypographyProps,
  space,
  SpaceProps
} from 'styled-system';
import styled, { DefaultTheme, StyledComponent } from 'styled-components';
import { setFormInputStyle } from '../Form.style';
import Button from '../../Button';

interface IInputProps {
  disabled?: boolean;
  hasError?: boolean;
  /**
   * React ref that gets forwarded to HTML input element.
   */
  ref?: any;
}

export type StyledInputProps = BackgroundColorProps &
  SpaceProps &
  BorderProps &
  TypographyProps;

interface PasswordIconProps {
  hasError?: boolean;
}

export const StyledInput: StyledComponent<
  'input',
  DefaultTheme,
  StyledInputProps & IInputProps,
  never
> = styled.input<StyledInputProps & IInputProps>`
  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-ms-clear,
  ::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }

  ${({ hasError, theme }) => `
    &:-webkit-autofill {
      box-shadow: 0 0 0 1000px ${theme.colors.grayScale[1]} inset;
      -webkit-text-fill-color: ${theme.colors.form.text.input.enabled};
    }
    &:-webkit-autofill:focus {
      -webkit-text-fill-color: ${theme.colors.form.text.input.enabled};
    }
    &:-webkit-autofill:active {
      -webkit-text-fill-color: ${theme.colors.form.text.input.enabled};
    }
    &:-webkit-autofill:first-line {
      font-size: ${theme.fontSizes[0]}px;
    }
    ${setFormInputStyle(hasError, theme)}
  `}

  ${compose(color, border, typography, space)}
`;

export const PasswordButton = styled(Button)<PasswordIconProps>`
  ${({ theme, hasError }) => `
    background: transparent;

    &:focus, :hover, :active {
      background: transparent;
      outline: none;
    }

    & > span {
      color: ${hasError ? theme.colors.state.danger : 'inherit'};
    }
  `}
`;

// vertically centers Icon on the right of the input
export const InputIconWrapper = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  height: 100%;
  position: absolute;
  top: 0px;
  right: 8px;
  color: ${({ theme, disabled }) =>
    theme.colors.form.text.input[disabled ? 'disabled' : 'enabled']};
`;
